export class ApiError extends Error {
    constructor(err) {
        super();
        this.name = "ApiError";
        if (typeof err === "string") {
            this.message = err.message;
        } else if (err.response) {
            this.status = err.response.status;
            if (err.response.data) {
                this.message = err.response.data.message;
                this.errors = err.response.data.errors;
                this.required = err.response.data.required;
                this.payload = err.response.data.payload;
            }
        } else {
            this.status = err.status;
            this.message = err.message;
            this.required = err.required;
            this.payload = err.payload;
        }
    }
}